import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";  // ✅ 注意加上 .jsx 扩展名
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
